import { fetchBanner } from '@/api';

const namespaced = true;

const state = {
	mainBannerList: [],
};

const getters = {
	mainBannerList(state) {
		return state.mainBannerList;
	},
};

const mutations = {
	setMainBannerList(state, list) {
		state.mainBannerList = list || [];
	},
};

const actions = {
	getMainBannerList({ commit }) {
		return fetchBanner()
			.then(response => {
				const S3_BASE_URL = process.env.VUE_APP_S3_BASE_URL;

				const mainBannseList = (response.data.banner || []).map(banner => {
					const { wb_filename } = banner;
					const basePath = '/himo-app/uploads/rolling_banner/';

					const hasFullPath = wb_filename.includes(basePath);
					const uploadPath = hasFullPath
						? `${S3_BASE_URL}${wb_filename}`
						: `${S3_BASE_URL}${basePath}${wb_filename}`;

					return {
						...banner,
						upload_url: uploadPath,
					};
				});

				commit('setMainBannerList', mainBannseList);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
